/* Dreya x Arishfa pop-up. No dependencies. */
(function () {
  var root = document.getElementById('dap');
  if (!root) return;

  var params = new URLSearchParams(window.location.search);
  var force = params.get('dap') === '1';
  var handle = root.getAttribute('data-handle') || '';
  var version = root.getAttribute('data-version') || 'v1';
  var maxVisits = parseInt(root.getAttribute('data-visits') || '3', 10);
  var delay = parseFloat(root.getAttribute('data-delay') || '4') * 1000;
  var intervalMs = parseFloat(root.getAttribute('data-interval') || '5') * 1000;
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var autoplay = root.getAttribute('data-autoplay') === 'true' && !reduced;

  // Campaign end: after the last day set in the section, stay away.
  var until = root.getAttribute('data-until');
  if (!force && until) {
    var end = new Date(until + 'T23:59:59+05:30');
    if (!isNaN(end) && Date.now() > end.getTime()) return;
  }

  // 16 Oct 2026: once per visit, on a visitor's first few visits only.
  // A visit is a browser session; the first page of each new session counts one.
  var VISITS = 'dreya_dap_visits_' + version;  // localStorage: visits so far
  var SESSION = 'dreya_dap_session_' + version; // sessionStorage: this visit already counted
  var SHOWN = 'dreya_dap_shown_' + version;     // sessionStorage: already shown this visit
  if (!force) {
    try {
      var visits = parseInt(window.localStorage.getItem(VISITS) || '0', 10);
      if (!window.sessionStorage.getItem(SESSION)) {
        visits += 1;
        window.localStorage.setItem(VISITS, String(visits));
        window.sessionStorage.setItem(SESSION, '1');
      }
      if (visits > maxVisits) return;
      if (window.sessionStorage.getItem(SHOWN)) return;
    } catch (e) { /* storage blocked: show it, once per page */ }
  }

  var dialog = root.querySelector('.dap__dialog');
  var track = root.querySelector('.dap__track');
  var slides = root.querySelectorAll('.dap__slide');
  var dots = root.querySelectorAll('[data-dap-dot]');
  var n = slides.length;
  var idx = 0;
  var timer = null;
  var lastFocus = null;

  function setInert(el, on) {
    if ('inert' in el) el.inert = on;
    el.setAttribute('aria-hidden', on ? 'true' : 'false');
  }

  function go(i, user) {
    idx = (i + n) % n;
    track.style.transform = 'translateX(' + (-idx * 100) + '%)';
    for (var k = 0; k < n; k++) {
      setInert(slides[k], k !== idx);
      dots[k] && dots[k].setAttribute('aria-current', k === idx ? 'true' : 'false');
    }
    if (user) restart();
  }

  function stop() { if (timer) { clearInterval(timer); timer = null; } }
  function restart() {
    stop();
    if (autoplay) timer = setInterval(function () { go(idx + 1); }, intervalMs);
  }

  function onKey(e) {
    if (e.key === 'Escape') { close(); return; }
    if (e.key === 'ArrowRight') go(idx + 1, true);
    if (e.key === 'ArrowLeft') go(idx - 1, true);
    if (e.key === 'Tab') {
      var f = dialog.querySelectorAll('a[href],button:not([disabled])');
      var list = [];
      for (var i = 0; i < f.length; i++) if (f[i].offsetParent !== null && !f[i].closest('[inert]')) list.push(f[i]);
      if (!list.length) return;
      var first = list[0], last = list[list.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }

  // The theme's other pop-ups share this flag, so only one is ever open.
  function open() {
    if (!force && (window.DREYA_POPUP_ACTIVE || window.DREYA_CHECKOUT_ACTIVE)) return;
    window.DREYA_POPUP_ACTIVE = true;
    lastFocus = document.activeElement;
    root.hidden = false;
    document.documentElement.classList.add('dap-lock');
    go(0);
    requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.add('is-open'); }); });
    dialog.focus({ preventScroll: true });
    document.addEventListener('keydown', onKey);
    restart();
    if (!force) { try { window.sessionStorage.setItem(SHOWN, '1'); } catch (e) {} }
  }

  function close() {
    stop();
    root.classList.remove('is-open');
    document.removeEventListener('keydown', onKey);
    document.documentElement.classList.remove('dap-lock');
    setTimeout(function () { root.hidden = true; }, 350);
    window.DREYA_POPUP_ACTIVE = false;
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  root.addEventListener('click', function (e) {
    var t = e.target.closest('[data-dap-close],[data-dap-prev],[data-dap-next],[data-dap-dot]');
    if (!t) return;
    if (t.hasAttribute('data-dap-close')) { if (t.tagName === 'A') e.preventDefault(); close(); }
    else if (t.hasAttribute('data-dap-prev')) go(idx - 1, true);
    else if (t.hasAttribute('data-dap-next')) go(idx + 1, true);
    else go(parseInt(t.getAttribute('data-dap-dot'), 10), true);
  });

  // Pause while hovering or focused inside, resume after.
  dialog.addEventListener('mouseenter', stop);
  dialog.addEventListener('mouseleave', restart);

  // Swipe on touch screens.
  var x0 = null, y0 = null;
  dialog.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
  dialog.addEventListener('touchend', function (e) {
    if (x0 === null) return;
    var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
    if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(idx + (dx < 0 ? 1 : -1), true);
    x0 = y0 = null;
  }, { passive: true });

  // 16 Oct 2026, when it opens:
  //   collection pages: after the delay (8 s);
  //   homepage: when she reaches the end of the page, or after a spell of no scrolling, tapping or typing (9 s).
  var opened = false;
  function openOnce() { if (opened) return; opened = true; cleanup(); open(); }
  var idleMs = parseFloat(root.getAttribute('data-idle') || '9') * 1000;
  var idleTimer = null;
  var EVENTS = ['scroll', 'touchstart', 'touchmove', 'keydown', 'mousedown', 'wheel'];
  function atEnd() {
    var doc = document.documentElement;
    return window.innerHeight + (window.scrollY || doc.scrollTop) >= doc.scrollHeight - 200;
  }
  function onActivity() {
    if (atEnd()) { openOnce(); return; }
    clearTimeout(idleTimer);
    idleTimer = setTimeout(openOnce, idleMs);
  }
  function cleanup() {
    clearTimeout(idleTimer);
    EVENTS.forEach(function (ev) { window.removeEventListener(ev, onActivity, { passive: true }); });
  }

  if (force) setTimeout(openOnce, 300);
  else if (root.getAttribute('data-page') === 'index') {
    EVENTS.forEach(function (ev) { window.addEventListener(ev, onActivity, { passive: true }); });
    idleTimer = setTimeout(openOnce, idleMs);
  } else setTimeout(openOnce, delay);
})();
